var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`ll-skeleton ll-skeleton--${_vm.component}`, { animated: _vm.animated }]},[_c(_vm.components[_vm.type],{tag:"component",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }